import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  canvas: {
    width: '100%',
    marginRight: theme.spacing(-8),
    background: theme.palette.canvas.main,
    position: 'sticky',
    top: 64,
    height: 'calc(100vh - 190px)',
    overflowY: 'auto',
    overflowX: 'auto',
    padding: theme.spacing(3),
    pointerEvents: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  colorSelectorWidth: {
    width: theme.spacing(33.125),
    marginRight: theme.spacing(-1.75),
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: theme.spacing(9.75),
    justifyContent: 'flex-end',
  },
  canvasColorContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    background: '#FFFFFF',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.cardBorder.dark}`,
  },
  sectionTitle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterDpacing: '0.1px',
    width: theme.spacing(14),
  },
  cardWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))
